<template>
  <div>
    <CommonExpansionPanel :currentPanel="0">
      <template #title-panel > Carga de Emisiones Alianzas </template>

      <v-col cols="12" class="text-end">
        <v-btn
          dark
          color="#00a7e4"
          rounded
          class="mr-2"
          @click="showReglas = true"
        >
          Ver estructura del archivo
        </v-btn>
      </v-col>
      <v-expansion-panel-content>
        <CargaEmisionesAlianzasFilters
        />

        <hr />
        <CargaEmisionesAlianzasGenericasTable/>
      </v-expansion-panel-content>
    </CommonExpansionPanel>

    <v-dialog v-model="showReglas" max-width="900">
      <v-card>
        <v-card-title class="headline">
          Estructura esperada del archivo
        </v-card-title>

        <v-card-text>
          <v-alert type="info" outlined dense class="mb-4">
            El archivo de ejemplo incluye una fila con datos ficticios para mostrar el formato.
            <strong>Elimínala antes de cargar el archivo.</strong>
          </v-alert>
          <v-simple-table>
            <thead>
              <tr>
                <th>Incluir en layout</th>
                <th>Campo</th>
                <th>Obligatorio</th>
                <th>Notas</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="campo in reglasLayout" :key="campo.campo">
                <td>
                  <v-checkbox
                    v-model="campo.incluir"
                    :disabled="campo.obligatorio"
                    color="#00a7e4"
                    hide-details
                    dense
                    class="mt-0 pt-0"
                  />
                </td>
                <td>{{ campo.campo }}</td>
                <td>
                  <v-chip small :color="campo.obligatorio ? 'red' : 'grey'" dark>
                    {{ campo.obligatorio ? "Sí" : "No" }}
                  </v-chip>
                </td>
                <td>{{ campo.notas }}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>

        <v-card-actions>
          <v-btn @click="descargarEjemplo" outlined color="#00a7e4" rounded>
            <v-icon left>mdi-download</v-icon>
            Descargar CSV de ejemplo
          </v-btn>
          <v-spacer />
          <v-btn @click="showReglas = false" dark color="#00a7e4" rounded class="mr-2">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import CommonExpansionPanel from "@/components/commonComponents/CommonExpansionPanel.vue";
import CargaEmisionesAlianzasFilters from "./CargaEmisionesAlianzasFilters.vue";
import CargaEmisionesAlianzasGenericasTable from "./CargaEmisionesAlianzasGenericasTable.vue";

export default {
  components: {
    CommonExpansionPanel,
    CargaEmisionesAlianzasFilters,
    CargaEmisionesAlianzasGenericasTable,
  },
  data() {
    return {
      layout: [],
      producto_id: null,
      alianza_intermx_id: null,
      loading: false,
      archivoValido: false,
      showReglas: false,
      reglasLayout: [
        { campo: "certificado", obligatorio: true, notas: "Obligatorio", ejemplo: "123456789" },
        { campo: "nombre", obligatorio: true, notas: "Obligatorio", ejemplo: "Juan" },
        { campo: "apellido_paterno", obligatorio: true, notas: "Obligatorio", ejemplo: "Pérez" },
        { campo: "apellido_materno", obligatorio: true, notas: "No obligatorio", ejemplo: "López" },
        { campo: "telefono_contacto", obligatorio: true, notas: "Obligatorio", ejemplo: "5512345678" },
        { campo: "correo_contacto", obligatorio: true, notas: "No obligatorio", ejemplo: "juanperez98@gmail.com" },
        { campo: "fecha_nacimiento", obligatorio: true, notas: "Formato dd/MM/yyyy", ejemplo: "15/03/1990" },
        { campo: "rfc", obligatorio: false, notas: "No obligatorio", ejemplo: "PELJ900315AB1" },
        { campo: "curp", obligatorio: false, notas: "No obligatorio", ejemplo: "PELJ900315HDFRPN09" },
        { campo: "genero", obligatorio: false, notas: "No obligatorio", ejemplo: "M" },
        { campo: "factura", obligatorio: false, notas: "No obligatorio", ejemplo: "1000001" },
        { campo: "fecha_factura", obligatorio: false, notas: "Formato dd/MM/yyyy", ejemplo: "01/10/2026" },
        { campo: "fecha_emision", obligatorio: false, notas: "Formato dd/MM/yyyy", ejemplo: "01/10/2026" },
        { campo: "inicio", obligatorio: true, notas: "Formato dd/MM/yyyy", ejemplo: "01/10/2026 00:01:00 a. m." },
        { campo: "fin", obligatorio: true, notas: "Formato dd/MM/yyyy", ejemplo: "01/11/2026 00:01:00 a. m." },
      ].map((r) => ({ ...r, incluir: r.obligatorio })),
    };
  },

  methods: {
    descargarEjemplo() {
      const campos = this.reglasLayout.filter((c) => c.obligatorio || c.incluir);
      const escapar = (valor) => {
        const texto = valor == null ? "" : String(valor);
        return /[",\n]/.test(texto) ? `"${texto.replace(/"/g, '""')}"` : texto;
      };

      const encabezado = campos.map((c) => c.campo).join(",");
      const fila = campos.map((c) => escapar(c.ejemplo)).join(",");
      const contenido = "\uFEFF" + encabezado + "\n" + fila + "\n";

      const blob = new Blob([contenido], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "plantilla_carga_emisiones.csv";
      link.click();
      URL.revokeObjectURL(url);
      this.showReglas = false;
    },

  },
};
</script>

<style scoped>
.v-expansion-panel {
  border-radius: 20px;
}

.v-expansion-panels {
  z-index: auto !important;
}

.v-expansion-panels:not(.v-expansion-panels--accordion):not(.v-expansion-panels--tile)
  > .v-expansion-panel--active {
  border-radius: 20px !important;
  background-color: #f7f8fa;
}

.v-expansion-panel-header {
  background-color: #f7f8fa;
  border-radius: 20px !important;
}

.error-details-title {
  display: flex !important;
  align-items: center !important;
  justify-content: flex-start !important;
}
</style>
